module.exports = __webpack_public_path__ + "img/34f9c57.jpg";